module.exports = __webpack_public_path__ + "static/media/Code.c512d36f.svg";